import Vue from "vue";
import App from "@/App.vue";
import store from "@/store";

// Importing the main routes for the App
import routes from "@/routes";

// Importing Master CSS
import "@/assets/styles/_reset.css";
import "@/assets/styles/_global.scss";
import "@/assets/styles/_framework.scss";

// Importing Mixin Functions
import GlobalFunctions from "@/mixins/Functions";
Vue.mixin(GlobalFunctions);

import GlobalVariables from "@/mixins/Variables";
Vue.mixin(GlobalVariables);

// Importing Font Awesome icons
import Unicon from "vue-unicons/dist/vue-unicons-vue2.umd";
import {
  uniAngleRight,
  uniAngleRightB,
  uniAngleLeft,
  uniAngleDown,
  uniBell,
  uniCancel,
  uniCheck,
  uniExchange,
  uniExclamationTriangle,
  uniExport,
  uniExternalLinkAlt,
  uniImagePlus,
  uniLock,
  uniMessage,
  uniPen,
  uniPhone,
  uniPlus,
  uniRedo,
  uniRepeat,
  uniTimes,
  uniTrashAlt,
  uniTruck,
  uniUpload,
  uniUser,
  uniVectorSquare,
  uniWhatsapp,
  uniSearch,
  uniArrowUpRight,
  uniCommentAlt,
  uniImport,
} from "vue-unicons/dist/icons";
Unicon.add([
  uniAngleRight,
  uniAngleRightB,
  uniAngleLeft,
  uniAngleDown,
  uniBell,
  uniCancel,
  uniCheck,
  uniExchange,
  uniExclamationTriangle,
  uniExport,
  uniExternalLinkAlt,
  uniImagePlus,
  uniLock,
  uniMessage,
  uniPen,
  uniPhone,
  uniPlus,
  uniRedo,
  uniRepeat,
  uniTimes,
  uniTrashAlt,
  uniTruck,
  uniUpload,
  uniUser,
  uniVectorSquare,
  uniWhatsapp,
  uniSearch,
  uniArrowUpRight,
  uniCommentAlt,
  uniImport
]);
Vue.use(Unicon);

Vue.config.productionTip = false;

const router = () => {
  return routes;
};

new Vue({
  store,
  router: router(),
  render: (h) => h(App),
}).$mount("#app");
